import { RootState } from 'src/redux/store';

export const selectHotelsConfig = (state: RootState) => state.hotels.hotelsConfig;
